module.exports = __webpack_public_path__ + "assets/lessons/hr/lesson6/pages/lesson_6_5.pdf";